
import postcssStyledJsxUrlLoader_0 from '../../images/book-demo-background.svg';
import postcssStyledJsxUrlLoader_1 from '../../images/book-demo-background.svg';
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

body {
  position: relative;
  min-height: 100vh;
}

// The following selector will serve both “Book Custom Demo” and “Welcome to Intercom”
// since the “.book-custom-demo” class is added though the corresponding Page Behavior.
#layout-wrapper.book-custom-demo {
  header#site-header {
    height: auto;
    background-color: $white;
    transition: padding 0.24s ease, background-color 0.24s ease;

    &.header--fixed {
      background-color: $white;
    }
  }
}

#layout-wrapper.inbound-page {
  header#site-header {
    position: fixed;
    padding-bottom: 1rem;

    & > .container {
      max-width: 1300px;
    }
  }

  #main {
    padding-top: 0;
  }

  .doubleviewhero-main .marketo-form-wrapper {
    padding: 0 0.5rem;

    .form .submit-button {
      margin-top: 0;
    }
  }
}

#layout-wrapper.book-custom-demo:not(.inbound-page) {
  margin: 0 auto;
  max-width: $viewport-max-width;

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    top: 0;
    right: 0;
    left: 0;
    background-image: url("${postcssStyledJsxUrlLoader_0}");
    background-repeat: no-repeat;
    background-position: right;
    background-size: cover;
    transition: background-position 0.12s ease;
  }

  header#site-header {
    padding: 2rem calc(100% / 14) 1rem;

    .container {
      position: relative;
      margin: 0;

      .logo-wrapper {
        margin-left: 0;
      }
    }
  }

  main#main {
    padding: 2.75rem 0;
  }

  .hero-wrapper {
    align-content: start;

    &--white {
      background: transparent;
    }
  }

  .hero {
    grid-column: content;
    max-width: 100%;

    .content {
      justify-items: start;
    }
  }

  .main-headline {
    max-width: 100%;
    margin-bottom: 3.25rem;
    text-align: left;
  }

  .subheading {
    display: none;
    margin-bottom: 2.5rem;

    span {
      font-size: 1.375rem;
    }
  }

  .list-container {
    text-align: left;

    .headline {
      padding-bottom: 1rem;
    }

    .checkmarks {
      margin-left: 0;
    }

    .checkmarks-item {
      margin-right: 0;
      position: relative;

      .bullet-point {
        position: absolute;
        top: 0.375rem;
      }

      span:nth-child(2) {
        display: block;
        margin-left: 1.25rem;
      }
    }
  }

  .checkmarks-item span {
    font-size: 1rem;
    line-height: 1.65;
  }

  .cta-wrapper .cta {
    margin-bottom: 0;
  }
}

button.hidden {
  visibility: hidden;
}

@media (orientation: landscape) {
  #layout-wrapper.book-custom-demo:not(.inbound-page) {
    &:before {
      background-size: cover;
      background-position: 0% 116vh;
    }
  }
}

@media (min-width: 40.5em) and (orientation: landscape) {
  #layout-wrapper.book-custom-demo:not(.inbound-page) {
    &:before {
      background-position: 0% 92vh;
    }
  }
}

@include media-query(tablet) {
  #layout-wrapper.book-custom-demo {
    header#site-header {
      background-color: transparent;
    }
  }

  #layout-wrapper.book-custom-demo:not(.inbound-page) {
    &:before {
      background-image: url("${postcssStyledJsxUrlLoader_1}");
      background-position: 100% 0%;
      background-size: contain;
    }

    header#site-header {
      padding: 2rem calc(100% / 26) 1rem;
    }

    main#main {
      padding: 4.5rem 0 3rem;
    }

    .hero-wrapper {
      grid-template-columns: [left-gutter] 0.5fr [content] 12fr [right-gutter] 0.5fr;
    }
  }
}

@media (min-width: 48em) and (orientation: portrait) {
  #layout-wrapper.book-custom-demo:not(.inbound-page) {
    &:before {
      background-size: cover;
    }
  }
}

@media (min-width: 75em) {
  #layout-wrapper.book-custom-demo:not(.inbound-page) {
    &:before {
      background-position: 100% 50%;
      background-size: contain;
    }

    header#site-header {
      padding: 3rem calc(100% / 26) 1.5rem;
    }

    main#main {
      padding: 4rem 0;
    }

    .main-headline span {
      font-size: 4.5rem;
    }

    .subheading {
      display: block;
    }
  }
}

@include media-query(desktopLg) {
  #layout-wrapper.inbound-page {
    .doubleviewhero-main .marketo-form-wrapper {
      padding: 0 3rem;
    }
  }

  #layout-wrapper.book-custom-demo:not(.inbound-page) {
    &:before {
      background-position: 100% 0;
    }

    header#site-header {
      .container {
        max-width: 100%;
      }
    }

    .subheading span {
      font-size: 1.625rem;
    }
  }
}

@media (min-width: 120em) {
  #layout-wrapper.book-custom-demo:not(.inbound-page) {
    max-width: 117.5rem;

    main#main {
      padding: 5rem 0 4rem;
    }

    .subheading span {
      font-size: 2.25rem;
    }

    .list-container {
      .headline span {
        font-size: 1.25rem;
      }

      .checkmarks-item {
        span {
          font-size: 1.5rem;
        }

        .bullet-point {
          top: 0.875rem;
        }
      }
    }
  }
}
`